<template>
  <div>
    <p>{{ $t('text.sessExp')}}</p>
    <v-btn color="primary" href="/login">{{ $t('button.logout')}}</v-btn>
  </div>
</template>

<script>
export default {
  name: "neoparent-sess-exp"
}
</script>

<style scoped>

</style>
